import axios from 'axios'
import { useOktaAuth } from '@okta/okta-react'
import { useMemo } from 'react'

// Create a base axios instance with common headers
const baseAxiosInstance = axios.create()

baseAxiosInstance.defaults.headers.common = {
	'Content-Type': 'application/json',
	Accept: 'application/json',
	'Access-Control-Allow-Origin': '*',
	'Access-Control-Allow-Credentials': true,
	'Access-Control-Allow-Headers': 'X-Requested-With,content-type'
}

// Create a hook that returns an authenticated axios instance
export const useAuthenticatedAxios = () => {
	const { oktaAuth } = useOktaAuth()

	return useMemo(() => {
		// Create a new axios instance that extends the base instance
		const authenticatedAxios = axios.create()

		// Copy the default headers from the base instance
		authenticatedAxios.defaults.headers.common = { ...baseAxiosInstance.defaults.headers.common }

		// Add a request interceptor to automatically add the access token
		authenticatedAxios.interceptors.request.use(
			config => {
				const accessToken = oktaAuth.getAccessToken()
				if (accessToken) {
					config.headers.Authorization = `Bearer ${accessToken}`
				}
				return config
			},
			error => {
				return Promise.reject(error)
			}
		)

		return authenticatedAxios
	}, [oktaAuth])
}

// Export the base axios instance for use in non-authenticated requests
export const axiosInstance = baseAxiosInstance
